export const MAX_MOBILE_WINDOW_WIDTH = 910;

export type ScreenSize = 'mobile' | 'normal';

export const marketplacesWithTransparency: Record<string, string> = {
  'AU': 'A39IBJ37TRP1C6',
  'CA': 'A2EUQ1WTGCTBG2',
  'DE': 'A1PA6795UKMFR9',
  'ES': 'A1RKKUPIHCS9HS',
  'FR': 'A13V1IB3VIYZZH',
  'IN': 'A21TJRUUN4KGV',
  'IT': 'APJ6JRA9NG5V4',
  'JP': 'A1VC38T7YXB528',
  'UK': 'A1F83G8C2ARO7P',
  'US': 'ATVPDKIKX0DER',
};
